var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "email-wrap"
  }, [_vm.wayType === 'email' ? _c('div', {
    staticClass: "email-inner"
  }, [_c('email-input', {
    on: {
      "changeErrorTxt": _vm.changeErrorTxtHandle,
      "changeEmail": _vm.changeEmailHandle,
      "btnSure": _vm.next
    }
  }), _vm._v(" "), _c('error-tip', {
    ref: "errorTip",
    attrs: {
      "txt": _vm.errorTxt
    }
  }), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.next'))
    },
    on: {
      "btnSure": _vm.next
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-email' ? _c('div', {
    staticClass: "memail-inner"
  }, [_c('title-txt', {
    attrs: {
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.logReg')))
    }
  }), _vm._v(" "), _c('desc-txt', {
    attrs: {
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.phEmailTips'))
    }
  }), _vm._v(" "), _c('email-input', {
    attrs: {
      "mb": "mb"
    },
    on: {
      "changeErrorTxt": _vm.changeErrorTxtHandle,
      "changeEmail": _vm.changeEmailHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    ref: "errorTip",
    attrs: {
      "txt": _vm.errorTxt,
      "mb": "mb"
    }
  }), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "mb": "mb",
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.next'))
    },
    on: {
      "btnSure": _vm.next
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };